import { CoreApi, ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds, Entity, TransformUtils } from '@inter-ikea-core/core';
import { CommunicationSizeComponent } from '@inter-ikea-core/core';

const sortByHeightPlacement = (a: Entity, b: Entity) => {
  return TransformUtils.worldPosition(b).Y - TransformUtils.worldPosition(a).Y;
};

export const getMinHeightForSolution = (coreApi: CoreApi, solutionHeight: number) => {
  const DEFAULT_HEIGHT_MARGIN: number = 10;
  const SLIDING_DOOR_HEIGHT_MARGIN: number = 20;
  const HANGING_FRAME_MARGIN: number = 50;
  const LOFT_BED_MIN_HEIGHT: number = 2400;

  const frames = coreApi.entities.getByComponent(ComponentIds.FRAME_COMPONENT_ID);
  const hangingframes = frames.filter(frame => coreApi.entities.isEntityPlacedOnWall(frame));
  const loftBedInScene = coreApi.entities.getByProductType(ProductType.SMASTAD_LOFT_BED).length > 0;
  const highestPlacedHangingFrame = hangingframes.sort(sortByHeightPlacement)[0];
  const heightOfhighestPlacedHangingFrame = highestPlacedHangingFrame
    ? TransformUtils.worldPosition(highestPlacedHangingFrame).Y +
      coreApi.entities.getEntityComSize(highestPlacedHangingFrame)!.height / 2
    : 0;

  const maxFrameHeight = Math.max(
    ...frames.map(
      frame =>
        frame.getComponent<CommunicationSizeComponent>(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)
          ?.size.height || 0
    )
  );
  const highestFrames = frames.filter(
    frame =>
      frame.getComponent<CommunicationSizeComponent>(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)
        ?.size.height === maxFrameHeight
  );
  if (
    highestFrames.find(
      frame =>
        coreApi.entities.getDescendantsWithProductType(frame, ProductType.PAX_OUTER_LIGHT).length >
        0
    )
  ) {
    // One of the highest frames has outer lights
    return solutionHeight + DEFAULT_HEIGHT_MARGIN;
  } else if (
    highestFrames.find(frame =>
      coreApi.entities.findEntityInHierarchyWithOneOfProductTypes(frame, [
        ProductType.PAX_SLIDING_DOOR_REGULAR_ASM,
        ProductType.PAX_SLIDING_DOOR_WITH_PANELS_ASM
      ])
    )
  ) {
    // One of the highest frames has sliding doors
    return solutionHeight + SLIDING_DOOR_HEIGHT_MARGIN;
  } else if (loftBedInScene && solutionHeight < LOFT_BED_MIN_HEIGHT) {
    // Minimum ceiling height for loft bed is 240cm
    return LOFT_BED_MIN_HEIGHT;
  }
  return Math.max(
    solutionHeight + DEFAULT_HEIGHT_MARGIN,
    heightOfhighestPlacedHangingFrame + HANGING_FRAME_MARGIN
  );
};
